import { useState, useCallback, useEffect } from 'react';
import { Grid, Typography, Select, FormControl, MenuItem, Paper, Fab, Button, OutlinedInput, InputLabel } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import './styles.css';
import Fingerboard from '../Fingerboard';
import { accidentalDataConvert } from '../../hooks/dataHooks';
import { useAnime } from '../../hooks/AnimeProvider';

const AnswerForm = (props) => {
  const { onSubmit, isSmallScreen, has3rdPos, path, isMix1stAnd3rdPos, fingerForMixPositionQuestion } = props;
  const { anime } = useAnime();
  const [noteBaseName, setNoteBaseName] = useState('');
  const [accidental, setAccidental] = useState('')
  const [chosenString, setChosenString] = useState('');
  const [fingering, setFingering] = useState('');
  const [position, setPosition] = useState(0);
  const [handPosition, setHandPosition] = useState(0);
  const [showStep2, setShowStep2] = useState(false)
  const [showStep3, setShowStep3] = useState(false)

  const onRefresh = useCallback(() => {
    setNoteBaseName('')
    setAccidental('')
    setChosenString('')
    setFingering('')
    setPosition(0)
    setHandPosition(0)
    setShowStep2(false)
    setShowStep3(false)
  }, [])

    useEffect(() => {
      onRefresh()
    }, [path, onRefresh])

  const onNoteBaseNameChange = (e) => setNoteBaseName(e.target.value);
  const onAccidentalChange = (e) => setAccidental(e.target.value)
  const onStringChange = (e) => setChosenString(e.target.value)
  const onFingeringChange = (e) => setFingering(e.target.value);
  const onHandPositionChange = (e) => setHandPosition(e.target.value);
  
  const handleOnSubmit = () => {
    onSubmit(noteBaseName, accidental, chosenString, fingering, handPosition, position);
    onRefresh();
  }

  return (
    <>
      <Paper 
        elevation={8} 
        className="answerForm" 
        style={{
          borderRadius:'15px', 
          backgroundColor: 'whitesmoke',
          backgroundImage: `url(${anime.url})`
        }
      }>
          <Grid container direction="column">
              <Grid justifyContent="flex-end" direction="row" container>
                <Fab color="extended" aria-label="refresh" size='small' onClick={onRefresh}>
                  <RefreshIcon />
                </Fab>
              </Grid>
              {/**Step 1 Area */}
              <Grid item>
                <Typography id="instructionText">Step 1: What's the name of this note?</Typography>
                  {showStep2 ?
                    <>
                      <Grid justifyContent="center" direction="row" container>
                        <Typography className="myAnswer">{noteBaseName}{accidentalDataConvert(accidental)}</Typography>
                      </Grid>
                    </>
                  :
                    <>
                      <FormControl size="small" fullWidth>
                      <InputLabel htmlFor='note-name-input' color='secondary'>Name</InputLabel>
                          <Select
                              name='note-name-select'
                              value={noteBaseName}
                              onChange={onNoteBaseNameChange}
                              color='secondary'
                              className='selectInput'
                              input={<OutlinedInput label="Name" id='note-name-input'  color='secondary' />}
                          >
                            <MenuItem disabled={noteBaseName === 'A'} value={'A'}>A</MenuItem>
                            <MenuItem disabled={noteBaseName === 'B'} value={'B'}>B</MenuItem>
                            <MenuItem disabled={noteBaseName === 'C'} value={'C'}>C</MenuItem>
                            <MenuItem disabled={noteBaseName === 'D'} value={'D'}>D</MenuItem>
                            <MenuItem disabled={noteBaseName === 'E'} value={'E'}>E</MenuItem>
                            <MenuItem disabled={noteBaseName === 'F'} value={'F'}>F</MenuItem>
                            <MenuItem disabled={noteBaseName === 'G'} value={'G'}>G</MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl size="small" fullWidth>
                          <InputLabel htmlFor='accidental-input' color='secondary'>♮, ♯ or ♭</InputLabel>
                          <Select
                              name='accidental-select'
                              value={accidental}
                              onChange={onAccidentalChange}
                              color='secondary'
                              className='selectInput'
                              input={<OutlinedInput id='accidental-input' label="Natural, b or #" color='secondary' />}
                          >
                            <MenuItem value={''} disabled={!accidental}>♮ natural --default--</MenuItem>
                            <MenuItem value={'b'} disabled={accidental === 'b'}>♭ flat</MenuItem>
                            <MenuItem value={'#'} disabled={accidental === '#'}>♯ sharp</MenuItem>
                          </Select>
                        </FormControl>
                    </>
                  }
              {!showStep2 &&
                <Grid justifyContent="flex-end" direction="row" container>
                  <Button disabled={!noteBaseName} id='nextButton' size='small' variant="contained" color="secondary" onClick={() => setShowStep2(true)}>
                    Next
                  </Button>
                </Grid>
              }
              </Grid>
              {/**Step 2 Area */}
              {showStep2 &&
                <>
                  <Grid item>
                    {/**If question is isMix1stAnd3rdPos, then we show the fingering and ask for which hand position */}
                    {isMix1stAnd3rdPos ?
                      <>
                        <Typography id="instructionText">Step 2: What's the hand position if the fingering is <strong>{fingerForMixPositionQuestion}</strong>?</Typography>
                        {showStep3 ?
                          <>
                            <Grid justifyContent="center" direction="row" container>
                              <Typography className="myAnswer">Position {handPosition}</Typography>
                            </Grid>
                          </>
                        :
                          <>
                            
                            <FormControl size="small" fullWidth>
                              <InputLabel htmlFor='fingering-input' color='secondary'>Hand Position</InputLabel>
                              <Select
                                  name='hand-position-select'
                                  value={handPosition}
                                  onChange={onHandPositionChange}
                                  color='secondary'
                                  className='selectInput'
                                  input={<OutlinedInput id='hand-position-input' label="Hand Position" color='secondary' />}
                                  >
                                  <MenuItem disabled value={0}></MenuItem>
                                  <MenuItem disabled={handPosition === 1} value={1}>1st Position</MenuItem>
                                  <MenuItem disabled={handPosition === 3} value={3}>3rd position</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        }
                      </>
                      : 
                      <>
                        <Typography id="instructionText">Step 2: What's the fingering for this note?</Typography>
                        {showStep3 ?
                          <>
                            <Grid justifyContent="center" direction="row" container>
                              <Typography className="myAnswer">{chosenString}{fingering}</Typography>
                            </Grid>
                          </>
                        :
                          <>
                            <FormControl size="small" fullWidth>
                              <InputLabel htmlFor='string-input' color='secondary'>String</InputLabel>
                              <Select
                                  name='string-select'
                                  value={chosenString}
                                  onChange={onStringChange}
                                  color='secondary'
                                  className='selectInput'
                                  input={<OutlinedInput id='string-input' label="String" color='secondary' />}
                              >
                                  <MenuItem disabled={chosenString === 'G'} value={'G'}>G string</MenuItem>
                                  <MenuItem disabled={chosenString === 'D'} value={'D'}>D string </MenuItem>
                                  <MenuItem disabled={chosenString === 'A'} value={'A'}>A string</MenuItem>
                                  <MenuItem disabled={chosenString === 'E'}value={'E'}>E string</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl size="small" fullWidth>
                              <InputLabel htmlFor='fingering-input' color='secondary'>Finger</InputLabel>
                              <Select
                                  name='fingering-select'
                                  value={fingering}
                                  onChange={onFingeringChange}
                                  color='secondary'
                                  className='selectInput'
                                  input={<OutlinedInput id='fingering-input' label="Finger" color='secondary' />}
                              >
                                  <MenuItem disabled={fingering === '0'} value={'0'}>0</MenuItem>
                                  <MenuItem disabled={fingering === '1'} value={'1'}>1</MenuItem>
                                  <MenuItem disabled={fingering === '2'} value={'2'}>2</MenuItem>
                                  <MenuItem disabled={fingering === '3'} value={'3'}>3</MenuItem>
                                  <MenuItem disabled={fingering === '4'} value={'4'}>4</MenuItem>
                              </Select>
                            </FormControl>
                        </>
                        }
                      </>
                    }
                    {!showStep3 &&
                      <Grid justifyContent="flex-end" direction="row" container>
                        <Button disabled={isMix1stAnd3rdPos ? !handPosition : !fingering || !chosenString} id='nextButton' size='small' variant="contained" color="secondary" onClick={() => setShowStep3(true)}>
                          Next
                        </Button>
                      </Grid>
                    }
                  </Grid>
                </>



              }
              {/**Step 3 Area */}
              {showStep3 && 
                <>
                  <Fingerboard 
                    position={position}
                    setPosition={setPosition}
                    isSmallScreen={isSmallScreen}
                    isReveal={false}
                    has3rdPos={has3rdPos}
                    isPitchTest={false}
                  />
                  <Grid justifyContent="flex-end" direction="row" container>
                    <Button onClick={() => handleOnSubmit(noteBaseName, accidental, chosenString, fingering, handPosition, position)} variant="contained" color="secondary" disabled={isMix1stAnd3rdPos ? !noteBaseName || !handPosition || !position : !noteBaseName || !chosenString || !fingering || !position}>
                      Submit
                    </Button>
                  </Grid>
                </>
              }
          </Grid>
      </Paper>
    </>
  )
}

export default AnswerForm;